"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var PreserveRefUrlController = /** @class */ (function (_super) {
    __extends(PreserveRefUrlController, _super);
    function PreserveRefUrlController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreserveRefUrlController.prototype.connect = function () {
        var value = this.data.get('value');
        if (!value || !window.history || !window.history.replaceState)
            return;
        var url = new URL(window.location.href);
        if (url.searchParams.get('ref') === value)
            return;
        url.searchParams.set('ref', value);
        window.history.replaceState(null, '', url.toString());
    };
    return PreserveRefUrlController;
}(stimulus_1.Controller));
exports.default = PreserveRefUrlController;
